import { render, staticRenderFns } from "./ZadiMain.vue?vue&type=template&id=3ce46b68&"
import script from "./ZadiMain.vue?vue&type=script&lang=js&"
export * from "./ZadiMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports